/* DillySocks — PDP-Layout Desktop (Sean 18.08.2026):
   Bilder scrollen weg, die RECHTE Spalte (Buybox + Team-Selection +
   "Details & Material") bleibt stehen.

   Damit die rechte Spalte als EINE Einheit klebt, wird .ds-pdp-below-gallery
   (im Markup ein Geschwister von .product-details, damit es auf Mobile
   unter der Buybox als eigenes Grid-Kind stehen kann) auf Desktop in
   .product-details hineingezogen — Horizons eigenes Sticky
   (.sticky-content--desktop) uebernimmt dann. Auf Mobile wird es wieder
   zurueckgestellt.

   Ist die rechte Spalte hoeher als der Viewport, wird sie so geklebt, dass
   beim Runterscrollen ihr UNTERES Ende am Viewport-Rand haengt (sonst waere
   der untere Teil erst nach allen Bildern erreichbar): CSS-Variable
   --ds-right-h, ausgewertet in dillysocks-tokens.css. */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 750px)');

  function apply() {
    var grid = document.querySelector('.product-information__grid');
    if (!grid) return;
    var below = grid.querySelector('.ds-pdp-below-gallery');
    var details = grid.querySelector('.product-details');
    if (!below || !details) return;

    if (mq.matches) {
      if (below.parentElement !== details) details.appendChild(below);
      measure(details);
    } else {
      if (below.parentElement === details) grid.appendChild(below);
      details.style.removeProperty('--ds-right-h');
    }
    applyMedia(grid);
  }

  /* Galerie-Spalte (Sean 02.11.2026): klebt mit dem UNTEREN Ende knapp
     ueber der schwebenden Kaufleiste (Horizons sticky-add-to-cart, fixed
     unten), wenn die Buybox laenger ist. --ds-left-gap = Abstand der
     Leiste zum Rand + ihre Hoehe + 16px Luft; ohne Leiste 24px. Die
     Leiste wird immer einberechnet (nicht nur wenn sichtbar), sonst
     wuerde die Galerie beim Ein-/Ausblenden der Leiste springen. */
  var roMedia = null;
  function leftGap() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar || getComputedStyle(bar).display === 'none') return 24;
    var bottom = parseFloat(getComputedStyle(bar).bottom) || 0;
    return Math.round(bottom + bar.offsetHeight + 16);
  }
  function setMedia(media) {
    media.style.setProperty('--ds-left-h', media.offsetHeight + 'px');
    media.style.setProperty('--ds-left-gap', leftGap() + 'px');
  }
  function applyMedia(grid) {
    var media = grid.querySelector(':scope > .product-information__media');
    if (!media) return;
    if (mq.matches) {
      setMedia(media);
      media.setAttribute('data-ds-sticky', '');
      if (!roMedia && 'ResizeObserver' in window) {
        roMedia = new ResizeObserver(function () { setMedia(media); });
        roMedia.observe(media);
      }
    } else {
      media.removeAttribute('data-ds-sticky');
      media.style.removeProperty('--ds-left-h');
      media.style.removeProperty('--ds-left-gap');
    }
  }

  var ro = null;
  function measure(details) {
    details.style.setProperty('--ds-right-h', details.offsetHeight + 'px');
    if (!ro && 'ResizeObserver' in window) {
      ro = new ResizeObserver(function () {
        details.style.setProperty('--ds-right-h', details.offsetHeight + 'px');
      });
      ro.observe(details);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
  document.addEventListener('shopify:section:load', function () { roMedia = null; ro = null; apply(); });
  window.addEventListener('resize', function () {
    var media = document.querySelector('.product-information__media[data-ds-sticky]');
    if (media) media.style.setProperty('--ds-left-gap', leftGap() + 'px');
  });
})();

/* ---- PDP-Titelzeile: Produktname immer EINZEILIG (Sean 27.10.2026) ----
   Lange Namen ("Aerzte ohne Grenzen - Heartfelt") brachen bisher auf zwei
   bis drei Zeilen um. Jetzt wird der Titel so weit verkleinert, bis er
   neben dem Preis in EINE Zeile passt; der Preis schrumpft gedaempft mit
   (halb so stark, aber nie groesser als der Titel), damit das Verhaeltnis
   stimmig bleibt. Untergrenze Titel 45 % der Basisgroesse — reicht das
   nicht (extrem langer Name), darf der Titel wieder umbrechen statt ueber
   den Rand zu laufen. Basisgroesse wird bei jedem Lauf neu gelesen (Media
   Queries), Lauf bei Laden, Fonts-Ready, Resize und Section-Reload.
   CSS dazu in dillysocks-tokens.css (.ds-titlefit). */
(function () {
  'use strict';

  var MIN_SCALE = 0.45;
  var PRICE_DAMP = 0.5;
  var PRICE_MIN = 0.7;
  var PRICE_BASE = 24;
  var GAP = 10;
  var STEP = 0.025;

  function innerWidth(el) {
    var cs = getComputedStyle(el);
    return el.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
  }

  function fitGroup(group) {
    var h1 = null;
    for (var i = 0; i < group.children.length; i++) {
      var c = group.children[i];
      if (c.classList.contains('text-block') && c.firstElementChild && c.firstElementChild.tagName === 'H1') {
        h1 = c.firstElementChild;
        break;
      }
    }
    if (!h1) return;
    var priceBlock = group.querySelector('.ds-price--main');

    group.classList.add('ds-titlefit');
    group.classList.remove('ds-titlefit--wrap');
    h1.style.fontSize = '';
    group.style.removeProperty('--ds-pricefit');

    var base = parseFloat(getComputedStyle(h1).fontSize);
    if (!base) return;
    var scale = 1;

    function avail() {
      // Grid-Variante (mit Kurzbeschreibung): Spalte 1 = Breite des
      // Titel-Textblocks (schrumpft mit, wenn der Preis kleiner wird).
      if (getComputedStyle(group).display === 'grid') return h1.parentElement.getBoundingClientRect().width;
      // Flex-Variante: Preisblock selbst ist schmal (.ds-price-row ist
      // display: contents), darum die breiteste Preis-Zeile messen.
      var w = 0;
      if (priceBlock) {
        w = priceBlock.getBoundingClientRect().width;
        var parts = priceBlock.querySelectorAll('.price, .compare-at-price, .ds-price-taxnote');
        for (var k = 0; k < parts.length; k++) w = Math.max(w, parts[k].getBoundingClientRect().width);
        w += GAP;
      }
      return innerWidth(group) - w;
    }
    function apply() {
      var px = base * scale;
      h1.style.fontSize = px.toFixed(2) + 'px';
      // Preis gedaempft mitschrumpfen, aber nie groesser als der Titel
      // (Preis-Basis 24px, siehe .ds-price--main .price in tokens.css).
      var p = Math.max(PRICE_MIN, 1 - (1 - scale) * PRICE_DAMP);
      p = Math.min(p, px / PRICE_BASE);
      group.style.setProperty('--ds-pricefit', p.toFixed(3));
    }

    for (var n = 1; n <= 40; n++) {
      if (h1.scrollWidth <= avail() + 0.5) return;
      var next = 1 - n * STEP;
      if (next < MIN_SCALE - 1e-6) break;
      scale = next;
      apply();
    }
    if (h1.scrollWidth > avail() + 0.5) group.classList.add('ds-titlefit--wrap');
  }

  function fitAll() {
    var groups = document.querySelectorAll('.product-details .group-block-content');
    for (var i = 0; i < groups.length; i++) fitGroup(groups[i]);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(fitAll, 80);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll);
  else fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  window.addEventListener('load', fitAll);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
